/**
 * Shared canvas layout: stable size vs. getBoundingClientRect / window resize quirks.
 * - Measure host with clientWidth/Height (+ computed style fallback for fixed icons).
 * - Ignore one-off collapsed reads vs. last stable size (tab sleep, transitions).
 * - Re-read devicePixelRatio on each layout (zoom, display change).
 */
(function (win) {
  'use strict';

  function readHostBox(host) {
    var cw = Math.max(0, Math.floor(host.clientWidth));
    var ch = Math.max(0, Math.floor(host.clientHeight));
    if (cw < 4 || ch < 4) {
      var rect = host.getBoundingClientRect();
      cw = Math.max(cw, Math.floor(rect.width));
      ch = Math.max(ch, Math.floor(rect.height));
    }
    return { cw: cw, ch: ch };
  }

  /**
   * Full-bleed section backgrounds (hero, trust, footer, etc.)
   */
  function measureCanvasHost(canvas, fallbackHost, opts) {
    var minW = opts.minW != null ? opts.minW : 280;
    var minH = opts.minH != null ? opts.minH : 180;
    var state = opts.state || { lastW: 0, lastH: 0 };

    var host = canvas && canvas.parentElement ? canvas.parentElement : fallbackHost;
    if (!host) {
      return { w: minW, h: minH, dpr: Math.min(win.devicePixelRatio || 1, 2) };
    }

    var box = readHostBox(host);
    var nw = Math.max(minW, box.cw);
    var nh = Math.max(minH, box.ch);

    if (state.lastW > minW && nw < state.lastW * 0.42) {
      nw = state.lastW;
      nh = state.lastH;
    } else if (nw > 0 && nh > 0) {
      state.lastW = nw;
      state.lastH = nh;
    }

    return { w: nw, h: nh, dpr: Math.min(win.devicePixelRatio || 1, 2) };
  }

  /**
   * Fixed square icons (Offers section, etc.)
   */
  function measureSquareCanvas(canvas, fallbackHost, opts) {
    var defaultSize = opts.size != null ? opts.size : 150;
    var minSize = opts.minSize != null ? opts.minSize : 100;
    var state = opts.state || { lastSize: 0 };

    var host = canvas && canvas.parentElement ? canvas.parentElement : fallbackHost;
    var nw = defaultSize;

    if (host) {
      var box = readHostBox(host);
      nw = Math.max(minSize, box.cw, box.ch);
    }

    if (nw < minSize + 1 && canvas && win.getComputedStyle) {
      var cs = win.getComputedStyle(canvas);
      var cssW = parseFloat(cs.width) || 0;
      var cssH = parseFloat(cs.height) || 0;
      nw = Math.max(nw, cssW, cssH, defaultSize);
    }

    nw = Math.max(minSize, Math.round(nw));

    if (state.lastSize > minSize && nw < state.lastSize * 0.42) {
      nw = state.lastSize;
    } else if (nw > 0) {
      state.lastSize = nw;
    }

    return { w: nw, h: nw, dpr: Math.min(win.devicePixelRatio || 1, 2) };
  }

  function applyCanvasBitmap(canvas, ctx, logicalW, logicalH, dpr) {
    var bw = Math.max(1, Math.floor(logicalW * dpr));
    var bh = Math.max(1, Math.floor(logicalH * dpr));
    if (canvas.width !== bw || canvas.height !== bh) {
      canvas.width = bw;
      canvas.height = bh;
    }
    if (canvas.style) {
      canvas.style.width = '';
      canvas.style.height = '';
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  win.EastSupplierCanvasLayout = {
    measure: measureCanvasHost,
    measureSquare: measureSquareCanvas,
    applyBitmap: applyCanvasBitmap,
  };
})(typeof window !== 'undefined' ? window : this);
